
import { useAuthTokenStore } from "@/store/useAuthTokenStore";
import { ApiResponse } from "@/types";
import axios, { AxiosResponse } from "axios";
import { storeToRefs } from "pinia";

const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
})

api.interceptors.request.use((config) => {
    const authStore = useAuthTokenStore();
    const { authToken } = storeToRefs(authStore)
    if (authToken.value) {
        config.headers.Authorization = `Bearer ${authToken.value}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});
export default class Network {
    static async post<T>(endpoint: string, params: unknown): Promise<T> {
        const response = await api.post<ApiResponse<T>>(`/${endpoint}`, params).catch((error) => { this.errorHandler(error) })
        return this.prepareResponse(response)
    }
    static async put<T>(endpoint: string, params: unknown): Promise<T> {
        const response = await api.put<ApiResponse<T>>(`/${endpoint}`, params).catch((error) => { this.errorHandler(error) })
        return this.prepareResponse(response)
    }
    static async get<T>(endpoint: string, params: unknown = {}): Promise<T> {
        const response = await api.get<ApiResponse<T>>(`/${endpoint}?`).catch((error) => { this.errorHandler(error) })
        return this.prepareResponse(response)
    }
    static async delete<T>(endpoint: string): Promise<T> {
        const response = await api.delete<ApiResponse<T>>(`/${endpoint}?`).catch((error) => { this.errorHandler(error) })
        return this.prepareResponse(response)
    }

    private static errorHandler(error: unknown): never {
        const message = axios.isAxiosError(error)
            ? error.response?.data?.message || 'Erro desconhecido'
            : 'Falha na requisição';
        this.showErrorMessage(message)
        throw new Error(message);
    }

    private static prepareResponse<R>(response: AxiosResponse<ApiResponse<R>>): R {
        if (!response.data.status) {
            this.showErrorMessage(response.data.message || 'Falha na requisição')
            throw new Error(response.data.message);
        }
        return response.data.data;
    }
    private static showErrorMessage(message: string) {
        console.log(message)
    }
}